import React, { FC, memo } from "react";

import { Form } from "./Form";
import { FormContainer } from "./FormContainer";

const SignInComponent: FC = () => {
  return (
    <FormContainer>
      <Form />
    </FormContainer>
  );
};

export const SignIn: FC = memo(SignInComponent);
